export const formatNumberWithCommas = (number: number | undefined): string => {
  console.log(`Number to format: ${number}`);
  if (number === undefined || number === null) {
    return '';
  }

  return Intl.NumberFormat('en-US').format(number);
};
